module.exports = __webpack_public_path__ + "img/delete_icon_grey.7f004edf.svg";